module.exports = __webpack_public_path__ + "static/media/Website.6f9b4821.jpg";